import { Link } from 'react-router-dom'
import InfoButton from '../../../components/InfoButton/InfoButton'
import '../Section.css'
import './SupplierManagerIndex.css'

function SupplierManagerIndex() {
  return (
    <div className="dashboard-section supplier-manager-index">
      <h1 className="supplier-manager-title">
        SUPPLIER MANAGER
        <InfoButton
          title="Supplier Manager"
          content={
            <div>
              <p>
                Your wedding supplier hub — Because behind every epic wedding, there&apos;s a team that makes the magic happen. 
                Compare quotes, track your bookings, and keep everything (and everyone) under control.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li><strong>Numbers, please:</strong> Compare quotes side by side, filter by price, and mark your favourites as booked</li>
                <li><strong>The chosen ones:</strong> Manage your contracted suppliers — arrival times, payments, and key dates</li>
                <li>Store contact information, rates, and important dates</li>
                <li>Track payments and due dates with reminders</li>
              </ul>
              <p>
                One dashboard, zero supplier chaos.
              </p>
            </div>
          }
        />
      </h1>
      <div className="supplier-manager-dashboard-subtitle">Dashboard</div>
      <div className="supplier-manager-cards-wrapper">
        <div className="supplier-manager-cards">
          <Link to="/dashboard/supplier-manager/numbers-please" className="subsection-card supplier-card">
            <h3>Numbers, please</h3>
          </Link>
          <div className="supplier-manager-chosen-wrapper">
            <Link to="/dashboard/supplier-manager/the-chosen-ones" className="subsection-card supplier-card">
              <h3>The chosen ones</h3>
            </Link>
            <div className="supplier-manager-illustration">
              <img src="/img/Camara.png" alt="" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupplierManagerIndex
